'use client'

import { Cell, Divider } from '@vinted/web-ui'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { isEmailValid } from '@marketplace-web/shared/email-validation'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { DeprecatedInputText } from '@marketplace-web/shared/ui-helpers'
import {
  renderValidation,
  useFormValidationMessage,
} from '@marketplace-web/vendor-abstractions/react-hook-form-ui'
import { SIGNUP_URL } from 'constants/routes'
import { useSelectTypeUrl } from '@marketplace-web/domain/identity'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { Field, FormModel } from './types'

type Props = {
  isLoginTipDisplayed: boolean
}

const UserEmailField = ({ isLoginTipDisplayed }: Props) => {
  const translate = useTranslate('help_contact_form.email')
  const {
    register,
    formState: { errors },
  } = useFormContext<FormModel>()
  const validationMessage = useFormValidationMessage(errors, 'help_contact_form')
  const isNonNativeFlowAbTestEnabled = useAbTest('non_native_flow')?.variant === 'on'
  const selectTypeUrl = useSelectTypeUrl()

  const [isUserEmailValid, setIsUserEmailValid] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')

  function renderFasterAnswerTip() {
    return (
      <>
        <Divider />
        <Cell
          title={translate('login_tip')}
          type={Cell.Type.Navigating}
          chevron
          url={isNonNativeFlowAbTestEnabled ? selectTypeUrl : SIGNUP_URL}
        />
      </>
    )
  }

  function handleChange({ target }) {
    setEmail(target.value)

    const isValid = isEmailValid(target.value)

    setIsUserEmailValid(isValid)
  }

  function validate() {
    if (!isUserEmailValid) {
      return translate('errors.invalid')
    }

    return undefined
  }

  return (
    <>
      <DeprecatedInputText
        {...register(Field.Email, {
          required: true,
          validate,
        })}
        styling="wide"
        onChange={handleChange}
        title={translate('title')}
        placeholder={translate('placeholder')}
        uncontrolled
        value={email}
        validation={renderValidation(
          validationMessage(Field.Email, { required: translate('errors.empty') }),
        )}
      />
      {isLoginTipDisplayed && renderFasterAnswerTip()}
    </>
  )
}

export default UserEmailField
